const actionTypes = {
    SET_ADS: 'ADS/SET_ADS'
};

const setAds = ads => {
    return {
        type: actionTypes.SET_ADS,
        payload: ads
    };
};

export default {
    actionTypes,
    setAds
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/ads.js